import React from "react";
import ReactDOM from "react-dom";

import NewsLetterOptionsForm from "./NewsLetterOptionsForm";

const NewsletterOptInOptOutPortal: React.FC = () => {
  const element = document.getElementById("NewsletterOptinout");

  if (!element) {
    return null;
  }

  const optInDiv = element.querySelector<HTMLDivElement>("#nlOptin");
  const optInElement = optInDiv?.parentElement;
  const optOutDiv = element.querySelector<HTMLDivElement>("#nlOptout");
  const optOutElement = optOutDiv?.parentElement;

  // Optout
  if (optOutDiv && optOutElement) {
    optOutElement.removeChild(optOutDiv);

    return ReactDOM.createPortal(<div>TODO: Opt out component</div>, optOutElement);
  }

  // Optin
  if (optInDiv && optInElement) {
    optInElement.removeChild(optInDiv);

    return ReactDOM.createPortal(<NewsLetterOptionsForm />, optInElement);
  }

  // No output at all
  return null;
};

export default NewsletterOptInOptOutPortal;
